import z from 'zod';
import { customEventBaseFields } from './base-fields';

const element = {
  type: z.string().optional(),
  value: z.string().optional(),
  ...customEventBaseFields,
};

export default {
  clicked: z.object(element),
};
